module.exports = __webpack_public_path__ + "img/retrospect-44.a5105caf.jpg";